import { Field } from "./field";
import { cr } from "fire-wind-water/core";

class Text extends Field {
  constructor(field) {
    super(field);
    const attr = [
      "textLimitType",
      "textRegularExpression",
      "textLength",
      "isSensitive"
    ];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.sensitivValue = "";
    this.sensitivDirty = false;
    this.displaySelectType = "TEXT";
    this.hasError();
  }

  resetValue() {
    this.dirty = true;
    this.sensitivDirty = true;
    this.hasError();
  }

  setSensitiveValue(val) {
    this.value = val;
    this.sensitivValue = val;
    this.sensitivDirty = false;
  }

  setValue(val) {
    this.value = val || null;
    this.dirty = true;
    this.sensitivDirty = true;
    this.hasError();
  }

  initValue(val) {
    this.setValue(val);
    this.setSensitiveValue(val);
    this.dirty = false;
    this.hasError();
  }

  hasError() {
    this.setError();
    // 如果是脱敏字段，且没有改变过初始值，不去校验
    if (
      parseInt(this.isSensitive) === 1 &&
      !this.sensitivDirty &&
      this.value === this.sensitivValue
    ) {
      if (this.value || parseInt(this.required) !== 1) {
        return;
      }
    }
    if (this.value) {
      if (this.textRegularExpression) {
        const reg = new RegExp(this.textRegularExpression, "g");
        if (!reg.test(this.value)) {
          this.error.pattern = true;
        }
        if (this.textLength && this.textLength > 0) {
          if (this.value.length > this.textLength) {
            this.error.maxLength = true;
          }
        }
      }
    } else {
      if (parseInt(this.required) === 1) {
        this.error.required = true;
      }
    }
    this.isError();
  }
}

export { Text };
